import { memo } from 'react';

import { useJourneyTravellerAction } from 'api/traveller-actions/hooks';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { PreviewSmsMenuItemView } from './preview-sms-menu-item';
import { buildSmsPreviewPropsFromTravellerAction } from './sms-preview';

const ACTION_TYPE = ACTION_TYPES.send_sms;

export const Node = memo((node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={getActionLabel(ACTION_TYPE)}
        descriptionText={node.data?.description}
      >
        <NodeActions node={node} customMenuItems={<PreviewSmsMenuItem actionId={node.id} />} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const PreviewSmsMenuItem = ({ actionId }: { actionId: string }) => {
  const { data: action } = useJourneyTravellerAction<typeof ACTION_TYPE>(actionId);

  return (
    <PreviewSmsMenuItemView
      previewProps={action ? buildSmsPreviewPropsFromTravellerAction(action) : undefined}
    />
  );
};
